<template>
  <b-modal
    :active.sync="isModalActive"
    has-modal-card
    trap-focus
    aria-modal="true"
    :aria-role="ariaRole"
    @close="onModalClose"
  >
    <div class="modal-card" :aria-labelledby="modalTitleId">
      <header class="modal-card-head">
        <b-icon
          icon="alert-circle"
          size="is-medium"
          type="is-danger"
          class="mr-2"
        />
        <p class="modal-card-title" :id="modalTitleId">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <p>
          {{ bodyText }}
          <b>{{ trashObjectName }}</b>
          {{ bodySuffix }}
        </p>
        <p class="has-text-grey mt-2">
          <b-icon icon="information-outline" size="is-small" class="mr-1" />
          Actiunea nu va putea fi anulata.
        </p>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="cancel">Anulare</button>
        <button class="button is-danger" @click="confirm">
          <b-icon icon="trash-can" size="is-small" class="mr-1" />
          {{ confirmText }}
        </button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
// Simple counter for generating unique IDs
let modalCounter = 0;

export default {
  name: "ModalBox",
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    trashObjectName: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Confirmare stergere",
    },
    bodyText: {
      type: String,
      default: "Inregistrarea",
    },
    bodySuffix: {
      type: String,
      default: "va fi stearsa definitiv.",
    },
    confirmText: {
      type: String,
      default: "Sterge",
    },
  },
  data() {
    return {
      isModalActive: false,
      triggerElement: null,
      modalTitleId: "modal-title-" + ++modalCounter,
      ariaRole: "alertdialog",
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
    onModalClose() {
      // Return focus to the element that triggered the modal
      if (this.triggerElement && this.triggerElement.focus) {
        this.$nextTick(() => {
          this.triggerElement.focus();
        });
      }
    },
  },
  watch: {
    isActive(newValue) {
      if (newValue) {
        // Store reference to currently focused element (the trigger button)
        this.triggerElement = document.activeElement;
      }
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    },
  },
};
</script>
